module.exports = __webpack_public_path__ + "img/WomensBG.4e72f16d.jpg";